import apiClient from '@/shared/api/apiClient';
import { DownloadSystemArtifactsQuery, DownloadSystemArtifactsResponse, GetCadwellApplicationHistoryResponse, GetSystemArtifactsQuery, GetSystemArtifactsResponse, GetSystemResponse, ListSystemsQuery, ListSystemsResponse, RequestSystemLogsRequest, RequestSystemLogsResponse, UploadSystemArtifactsRequest, UploadSystemArtifactsResponse } from '../domain/systems.types';

const API_BASE_URL = '/systems';

export const systemService = {
  getSystemList: async (query: ListSystemsQuery): Promise<ListSystemsResponse> => {
    const response = await apiClient.get<ListSystemsResponse>(
      API_BASE_URL,
      {params: query}
    );
    return response.data;
  },

  requestSystemLogs: async (request: RequestSystemLogsRequest): Promise<RequestSystemLogsResponse> => {
    const response = await apiClient.post<RequestSystemLogsResponse>(
      `${API_BASE_URL}/${request.systemId}/artifacts/retrieve-logs`
    );
    return response.data;
  },

  refreshSystemData: async (systemId: string): Promise<void> => {
    await apiClient.post(`${API_BASE_URL}/${systemId}/refresh`);
  },

  getSystem: async (systemId: string): Promise<GetSystemResponse> => {
    const response = await apiClient.get<GetSystemResponse>(
      `${API_BASE_URL}/${systemId}`
    );
    return response.data;
  },

  getCadwellApplicationHistory: async (systemId: string): Promise<GetCadwellApplicationHistoryResponse> => {
    const response = await apiClient.get<GetCadwellApplicationHistoryResponse>(
      `${API_BASE_URL}/${systemId}/cadwell-applications`
    );
    return response.data;
  },

  uploadSystemArtifacts: async (request: UploadSystemArtifactsRequest): Promise<UploadSystemArtifactsResponse> => {
    const formData = new FormData();

    // Append each file individually
    request.files.forEach((file) => {
      formData.append('files', file);
    });

    // Build query parameters
    const params = new URLSearchParams();
    params.append('systemId', request.systemId);

    const response = await apiClient.post<UploadSystemArtifactsResponse>(
      `/artifacts/upload?${params.toString()}`,
      formData
    );
    return response.data;
  },

  getSystemArtifacts: async (query: GetSystemArtifactsQuery): Promise<GetSystemArtifactsResponse> => {
    const {systemId} = query;

    const response = await apiClient.get<GetSystemArtifactsResponse>(
      `${API_BASE_URL}/${systemId}/artifacts`
    );
    return response.data;
  },

  getSystemArtifactDownloadUri: async (query: DownloadSystemArtifactsQuery): Promise<DownloadSystemArtifactsResponse> => {
    const response = await apiClient.get<DownloadSystemArtifactsResponse>(
      `/artifacts/download`,
      {params: query}
    );
    return response.data;
  },

  deleteSystemArtifact: async (artifactId: string): Promise<void> => {
    await apiClient.delete(`/artifacts/${artifactId}`);
  }
};